const path = {};

export {path};
